<template>
  <div class="home-main">
    <router-view />
    <Bottom />
  </div>
</template>

<script>
import Bottom from "@/components/home/BottomBar.vue";
export default {
  components: {
    Bottom
  }
};
</script>

<style lang="scss" scoped>
.home-main {
  height: 100%;
  width: 100%;
}
</style>
